import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";

const CountdownTimer = ({ start, onFinish, className }) => {
  const [seconds, setSeconds] = useState(start);

  useEffect(() => {
    if (seconds <= 0) {
      if (onFinish) onFinish();
      return;
    }

    const interval = setInterval(() => {
      setSeconds((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [seconds, onFinish]);

  return <span className={className}>{seconds}</span>;
};

CountdownTimer.propTypes = {
  start: PropTypes.number,
  onFinish: PropTypes.func,
  className: PropTypes.string,
};

CountdownTimer.defaultProps = {
  start: 60,
  onFinish: null,
  className: "",
};

export default CountdownTimer;
